const BookingsHeader = ({ searchTerm, onSearchChange, total }) => {
  return (
    <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
      <div>
        <h4 className="card-title mb-1">Bookings</h4>
        <small className="text-muted">Total: {total}</small>
      </div>

      <div style={{ minWidth: "280px", maxWidth: "360px", width: "100%" }}>
        <input
          type="text"
          className="form-control"
          placeholder="Search by customer, company, phone, reg #, status"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default BookingsHeader;
